
import { Field } from "@/utils/documents/field";
import { FreeBlock } from "@/utils/documents/free-block";
import Vue from "vue";
import AppDraggableResizeCombo from "@/components/layout-editor/DraggableResizeCombo.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getReminderMapPropSelectGroup } from "@/utils/prop-select/reminder-map-prop-group";

export default Vue.extend({
	props: {
		freeBlock: {
			type: Object as ()=>FreeBlock,
			required: true
		},
		lang: String
	},
	computed: {
		props(): PropSelectGroup {
			return getReminderMapPropSelectGroup();
		},
	},
	methods: {
		getPropValue(prop: Field): string {
			if (!prop.Prop) return "";
			let p = this.props.getPropSelectFromValue(prop.Prop);
			let name = this.$t("models.map.Reminder." + prop.Prop).toString();
			if (p) {
				name = p.text.toString();
			}
			return "<span class='field'>" + name  + "</span>";
		},
		getLineText(line:Field):string{
			let text =  line.Text.getTranslation(this.lang) + this.getPropValue(line) + line.TextAfter.getTranslation(this.lang);
			if (text == ""){
				return "&#8203;";
			}
			return text;
		}
	},
	components: {
		AppDraggableResizeCombo,
	}
});
